// import { alertActions } from "../config/action-config";

// export const successAlert = (message, onClose) => (dispatch) => {
//   dispatch({
//     type: alertActions.ALERT_SHOW,
//     severity: "success",
//     message,
//     onClose,
//   });
// };

// export const errorAlert = (message, onClose) => (dispatch) => {
//   dispatch({
//     type: alertActions.ALERT_SHOW,
//     severity: "error",
//     message,
//     onClose,
//   });
// };

// export const infoAlert = (message, onClose) => (dispatch) => {
//   dispatch({
//     type: alertActions.ALERT_SHOW,
//     severity: "info",
//     message,
//     onClose,
//   });
// };

// export const warningAlert = (message, onClose) => (dispatch) => {
//   dispatch({
//     type: alertActions.ALERT_SHOW,
//     severity: "warning",
//     message,
//     onClose,
//   });
// };

// export const hideAlert = () => async (dispatch) => {
//   dispatch({ type: alertActions.ALERT_HIDE });
// };

import { alertActions as actionTypes } from "../config/action-config.js";

export const showAlert = (message, onClose) => async (dispatch) => {
  dispatch({ type: actionTypes.SHOW, payload: { message, onClose } });
};

export const errorAlert = (message, onClose) => async (dispatch) => {
  dispatch({ type: actionTypes.ERROR, payload: { message, onClose } });
};

export const hideAlert = () => async (dispatch) => {
  dispatch({ type: actionTypes.HIDE });
};
